/*=========================================================================================
  File Name: moduleChat.js
  Description: Chat Module
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import state from "./moduleVideowikiState.js";
import mutations from "./moduleVideowikiMutations.js";
import actions from "./moduleVideowikiActions.js";
import getters from "./moduleVideowikiGetters.js";

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
